import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-gip-req-stat-alist',
  templateUrl: './gipReqStatAList.component.html',
  styleUrls: ['./gipReqStatAList.component.css']
})
export class GipReqStatAListComponent implements OnInit {

  constructor(
    private router: Router, 
    private shareData: SharingDataService,
    private toPicklist: ToPicklistPipe,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    ) { }

  urlString = "Admin/V_MS_STAT_ACTIVITY";
  resourceDefinition: any;
  Picklists;

  columns = [
    { name: "VID", visible: false, enableFilter: true, enableOrderBy: true, export: false, type: "text", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "toStatistic", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "ACTIVITY_TYPE", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "picklist", columnSearch: false, fromToFilter: false, picklistTableName: "V_MS_ACTIVITY_TYPE_VL_T", function: "toStatistic", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "REQ_CNT", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: false, fromToFilter: true, picklistTableName: null, function: "toStatistic", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
 
  ];


  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe((data) => this.Picklists = data);
  }

   action(parameters){
    this[parameters.action](parameters.element, parameters.column);
  }

  toStatistic(element, column){
    this.router.navigate([`/gipReqStatAAllList`], { queryParams: { id1: `${element.ACTIVITY_TYPE}`, company: `${this.toPicklist.transform(element.ACTIVITY_TYPE, this.Picklists.V_MS_ACTIVITY_TYPE_VL_T)}`} });
  }
}
